











































































import { Vue, Component, Prop } from 'vue-property-decorator'
import type { FormLoja } from '@/models'
import { obrigatorio } from '@/shareds/regras-de-form'
import { removerCaracteresEspeciaisDeTexto } from '@/shareds/formatadores'
import CampoDeCnpj from '@/components/ui/CampoDeCnpj.vue'
import ConfirmExclusionDialog from '@/components/ui/ConfirmExclusionDialog.vue'
import SeletorDeGruposEconomicos from '@/components/loja/SeletorDeGruposEconomicos.vue'

@Component({
	components: { CampoDeCnpj, ConfirmExclusionDialog, SeletorDeGruposEconomicos },
})
export default class SecaoDadosDaLoja extends Vue {
	@Prop({ type: Object, required: true }) loja!: FormLoja
	@Prop({ type: Boolean, default: false }) novo!: boolean
	@Prop({ type: Boolean, default: true }) podeEditar!: boolean
	@Prop({ type: Boolean, default: false }) excluindo!: boolean

	obrigatorio = obrigatorio
	removerCaracteresEspeciaisDeTexto = removerCaracteresEspeciaisDeTexto
}
